import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import WritingAssignment from './component';
import StudentSelect from './StudentSelect';
import ViewNav from 'components/ViewNav';
import WritingAssignmentSessionNav from 'components/WritingAssignmentSessionNav';
import {
  accessors as writingAssignmentOverview,
  status,
} from 'data/WritingAssignment';

export const EDIT = 'edit-comment';
export const PUBLISH = 'publish';
export const EXPORT = 'export';

const getWritingAssignment = (state, params) => {
  const { groupId, studentId } = params;
  const activity =
    writingAssignmentOverview.getStudentActivityByLessonCategory(
      state,
      groupId,
      params,
      studentId,
    ) || {};
  return writingAssignmentOverview.getWritingAssignmentByActivityType(
    state,
    activity.activityType,
    activity.activityId,
    studentId);
};

const actionButtons = (getState) => ({
  Publish: {
    isPrimary: true,
    visibleWhen: () =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.AssignHomework.Publish),
    disableWhen: (props) => {
      const writingAssignment = getWritingAssignment(getState(), props.params);
      const isShortAnswer = writingAssignmentOverview.isShortAnswer(props.activityType);
      return ! writingAssignmentOverview.canPublish(writingAssignment, isShortAnswer) ||
          WritingAssignment.isInEditMode(props);
    },
    route: './publish',
  },
  Export: {
    disableWhen: ({ params }) => {
      const writingAssignment = getWritingAssignment(getState(), params);
      return ! (writingAssignment &&
          writingAssignment.status.toLowerCase() === status.COMPLETE.toLowerCase());
    },
    route: './export',
  },
});

const appBars = () => ({
  sticky: {
    'session-nav': {
      component: WritingAssignmentSessionNav,
      order: 1,
    },
    'student-select': {
      component: StudentSelect,
      order: 2,
    },
    'view-nav': {
      component: ViewNav,
      order: 3,
    },
  },
});

const buildPath = (lessonCategory) => {
  switch (lessonCategory) {
    case 'coreCatchUp':
      return 'lesson/:lessonSeq/student/:studentId(/:mode)';
    case 'spin':
      return 'activity/:activityId/student/:studentId(/:mode)';
    default:
      return '';
  }
};

const getBreadcrumb = (props, getState) => {
  const { params: { groupId, lessonSeq, studentId } } = props;
  const activity =
    writingAssignmentOverview.getCoreActivityByLessonAndStudentId(
      getState(),
      groupId,
      lessonSeq,
      studentId,
    );
  const { activityType = '' } = activity;
  return {
    label: writingAssignmentOverview.formatActivityType(activityType),
    clickable: false,
  };
};

const buildRoute = (lessonCategory) => ({ getState }) => ({
  breadcrumbLabels: (props) => getBreadcrumb(props, getState),
  actionButtons: {
    default: actionButtons(getState),
    [EDIT]: actionButtons(getState),
    [EXPORT]: actionButtons(getState),
  },
  appBars: appBars(),
  path: buildPath(lessonCategory),
  canAccess: (props) => {
    if (! WritingAssignment.isInEditMode(props)) return true;
    return PrivilegeChecker.hasPrivilege(getState(), Privileges.AssignHomework.ManageOwn);
  },
  component: WritingAssignment,
});

export const coreCatchUpWritingAssignment = buildRoute('coreCatchUp');
export const spinWritingAssignment = buildRoute('spin');



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/StudentWritingAssignment/routes.js